<template>
    <div>
        <Separator icon="book-open" />
        <slot></slot>
    </div>
</template>
